import React, { useCallback } from 'react';
import useVideoStore from './stores/useVideoStore';
import { searchDoctors } from './api';
import HospitalSelector from '../shared/HospitalSelector';
import DoctorSelector from '../shared/DoctorSelector';
import TagsInput from './VideoTagsInput';
import CategoriesSelect from './VideoCategoriesSelect';
import SEOPanel from './VideoSEOPanel';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function FormSidebar({ hospitals, scheduleAutosave }) {
  var t = useTranslations();
  var hospitalId = useVideoStore(function(s) { return s.hospital_id; });
  var doctorIds = useVideoStore(function(s) { return s.doctor_ids; });
  var doctorNames = useVideoStore(function(s) { return s.doctor_names; });
  var updateField = useVideoStore(function(s) { return s.updateField; });
  var publishErrors = useVideoStore(function(s) { return s.publishErrors; });

  var handleHospitalSelect = useCallback(function(id) {
    updateField('hospital_id', id);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  var handleHospitalClear = useCallback(function() {
    updateField('hospital_id', '');
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  var ids = doctorIds || [];
  var names = doctorNames || [];

  var selectedDoctors = ids.map(function(id, index) {
    return { id: id, name: names[index] || 'Doctor #' + id, avatar: null };
  });

  var handleDoctorSelect = useCallback(function(doctor) {
    var newIds = ids.concat([doctor.id]);
    var newNames = names.concat([doctor.full_name || doctor.name]);
    updateField('doctor_ids', newIds);
    updateField('doctor_names', newNames);
    scheduleAutosave();
  }, [ids, names, updateField, scheduleAutosave]);

  var handleDoctorRemove = useCallback(function(index) {
    var newIds = ids.filter(function(_, i) { return i !== index; });
    var newNames = names.filter(function(_, i) { return i !== index; });
    updateField('doctor_ids', newIds);
    updateField('doctor_names', newNames);
    scheduleAutosave();
  }, [ids, names, updateField, scheduleAutosave]);

  return (
    <div className="form-sidebar__inner">
      <div className="form-sidebar__section" data-tour="hospital_selector">
        <h6 className="form-sidebar__heading">
          <i className="zmdi zmdi-assignment zmdi-hc-fw" /> {t.publishing_details}
        </h6>
        <div className="mb-3">
          <label className="form-label small text-muted mb-1">{t.hospital}</label>
          <HospitalSelector
            hospitals={hospitals || []}
            selectedId={hospitalId}
            onSelect={handleHospitalSelect}
            onClear={handleHospitalClear}
            errors={publishErrors && publishErrors.hospital_id ? publishErrors.hospital_id : null}
            translations={t}
          />
        </div>
        <div>
          <label className="form-label small text-muted mb-1">{t.doctor_label}</label>
          <DoctorSelector
            multiple={true}
            selectedDoctors={selectedDoctors}
            onSelect={handleDoctorSelect}
            onRemove={handleDoctorRemove}
            searchDoctors={searchDoctors}
            errors={publishErrors && publishErrors.doctor_ids ? publishErrors.doctor_ids : null}
            translations={t}
          />
        </div>
      </div>

      <div className="form-sidebar__section" data-tour="tags_panel">
        <h6 className="form-sidebar__heading">
          <i className="zmdi zmdi-labels zmdi-hc-fw" /> {t.tags}
        </h6>
        <TagsInput scheduleAutosave={scheduleAutosave} />
      </div>

      <div className="form-sidebar__section" data-tour="categories_panel">
        <h6 className="form-sidebar__heading">
          <i className="zmdi zmdi-folder zmdi-hc-fw" /> {t.categories}
        </h6>
        <CategoriesSelect scheduleAutosave={scheduleAutosave} />
      </div>

      <div className="form-sidebar__section" data-tour="seo_panel">
        <h6 className="form-sidebar__heading">
          <i className="zmdi zmdi-search zmdi-hc-fw" /> {t.seo}
        </h6>
        <SEOPanel scheduleAutosave={scheduleAutosave} />
      </div>
    </div>
  );
}
